export function getDashboardLandingRoute(roleName: string | null | undefined): '/admin-dashboard' | '/dashboard' {
  const normalizedRole = String(roleName ?? '').trim().toUpperCase();
  return normalizedRole.includes('ADMIN') ? '/admin-dashboard' : '/dashboard';
}
